export default "__VITE_ASSET__BIwHJN3S__"